import React from 'react';

const JobsCount = ({ data, history }) => {
    return (
        <div className='d-flex justify-content-between m-3'>
            {data.map(({ count, filterData, status }) =>
                <div key={status} style={{minWidth: '150px'}} className='col-md-3 d-flex flex-column align-items-center justify-content-center m-3 py-3 px-4 c-pointer border rounded-1' onClick={() => history.push(`/jobs${filterData}`)}>
                    <div className='font-20'>{count}</div>
                    <div className='pt-2'>{status}</div>
                </div>
            )}
        </div>
    );
};

export default JobsCount;